import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Wand2, X } from "lucide-react";

export const AdminChangeRequest = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  if (!user?.is_admin) return null;

  const submit = async () => {
    if (note.trim().length < 3) { toast.error("Describe the change you want."); return; }
    setBusy(true);
    try {
      await api.createChangeRequest(pathname, note.trim());
      toast.success("Change request saved! Find it in your Admin panel — paste it into the Emergent chat and it gets built.");
      setNote(""); setOpen(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't save the request.");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed bottom-4 left-4 z-50" data-testid="admin-change-widget">
      {open && (
        <div className="mb-3 w-80 rounded-2xl bg-white/95 backdrop-blur-lg shadow-2xl border-2 border-[#10B981]/50 p-5 space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-lg font-bold text-[#10B981]">Request a change</span>
            <button onClick={() => setOpen(false)} data-testid="admin-change-close"><X className="w-5 h-5 text-[#5A5A5A]" /></button>
          </div>
          <p className="text-lg text-[#3A3A3A] font-semibold leading-snug">Page: <span className="text-[#FF1A82] font-bold">{pathname}</span></p>
          <textarea value={note} onChange={e => setNote(e.target.value)} rows={4} maxLength={3000}
            placeholder="What needs to change on this page?"
            className="w-full bg-white/70 border border-black/15 rounded-xl px-3 py-2 text-lg text-[#1A1A1A] font-semibold outline-none focus:border-[#10B981] resize-none"
            data-testid="admin-change-note" />
          <button onClick={submit} disabled={busy} data-testid="admin-change-submit"
            className="w-full px-4 py-2.5 rounded-full bg-[#10B981] text-white font-bold text-lg hover:brightness-110 disabled:opacity-60">
            {busy ? "Saving…" : "Save change request"}
          </button>
        </div>
      )}
      <button onClick={() => setOpen(o => !o)} data-testid="admin-change-toggle"
        className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#10B981] text-white font-bold text-lg shadow-xl hover:brightness-110">
        <Wand2 className="w-5 h-5" /> Admin
      </button>
    </div>
  );
};
